import TutorialPage from "./tutorial-page"

export const QuizManagerTutorialPage = () => {

    return (
        <TutorialPage variant='quiz-manager'/>
    )

}